import FJVideoRemoveBgLeft from '../view/FJVideoRemoveBgLeft';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FJCodecStore from '../../../../store/FJCodecStore';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';

const FJVideoRemoveBgLeftContainer = () => {
    const dispatch = useDispatch();

    const curMenuIndex = useSelector(state => state.videoBgRemover.curMenuIndex);

    useEffect(() => {
        FJCodecStore.init();
    }, []);

    const _switchCurMenuIndex = useCallback(
        index => {
            dispatch(FJActionVideoRemoveBg.changeCurMenuIndexAction(index));
        },
        [dispatch],
    );

    return <FJVideoRemoveBgLeft switchCurMenuIndex={_switchCurMenuIndex} curMenuIndex={curMenuIndex} />;
};

export default FJVideoRemoveBgLeftContainer;
